module.exports = __webpack_public_path__ + "assets/img/yuerpay.d03a7078.svg";